<template>
    <div class="container">
        <div class="row">
            <div class="col-md-4 offset-md-4">
                <div class="text-center mt-5">
                    <div class="waiting-message" v-if="!errorState">
                        <div class="spinner-grow" role="status">
                            <span class="sr-only">Processing payment...</span>
                        </div>
                        <div class="message mt-3">
                            <p><strong>Processing payment...</strong><br>Your payment is being processed, please wait. You will be automatically redirected.</p>
                        </div>
                    </div>
                    <div class="error-message" v-if="errorState">
                        <div class="alert alert-warning" role="alert">
                        Sorry.. we could not look up your payment status. If the payment has been processed successfully you will receive an email. If you don't receive that, please contact customer support. We are sorry for the inconvenience.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "PaymentReturnHandlerNonFinal",

        props: {
            probeEndpoint: {
                type: String,
                required: true
            }
        },

        data: () => ({
            isFetching: false,
            errorState: false,
            fetchErrorCount: 0,
            maxFetchErrorCount: 10,
            maxProbeCallsCount: 100,
            probeCallsCount: 0,
            interval: 3000,
            probeCallInterval: null
        }),

        mounted () {
            const self = this;
            this.probeCallInterval = setInterval(function () {
                self.callProbe();
            }, this.interval);
        },

        watch: {
            fetchErrorCount: function (value) {
                if (value >= this.maxFetchErrorCount) {
                    clearInterval(this.probeCallInterval);
                    this.errorState = true;
                }
            },
            probeCallsCount: function (value) {
                if (value >= this.maxProbeCallsCount) {
                    clearInterval(this.probeCallInterval);
                    this.errorState = true;
                }
            }
        },

        methods: {
            callProbe() {
                // Do not send requests when one is still pending
                if (this.isFetching) return;

                this.isFetching = true;
                axios.get(this.probeEndpoint).then((res) => {
                    this.isFetching = false;
                    this.processResponse(res.data);
                    this.probeCallsCount++;
                }).catch((err) => {
                    this.isFetching = false;
                    this.fetchErrorCount++;
                })
            },
            processResponse(data) {
                if (data.finished !== true) {
                    return;
                }

                clearInterval(this.probeCallInterval);
                window.location.replace(data.redirectUrl);
            }
        }
    };
</script>